import { Navigate, Outlet, useLocation } from 'react-router';

import { useAuth } from '@/core/auth/use-auth';

export function AuthRoute() {
    const { isAuthenticated, initialized } = useAuth();
    const location = useLocation();

    if (!initialized) return null;

    if (!isAuthenticated) {
        const returnUrl = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/?returnUrl=${returnUrl}`} replace />;
    }

    return <Outlet />;
}
